import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {ReplacementDataMediumSourcesActions} from '../store';
import {ReplacementDataMediumSourcesSelectors} from '../store/selectors';

@Injectable()
export class ReplacementDataMediumSourcesLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadReplacementDataMediumSourcesDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadReplacementDataMediumSourcesDone() {

    return this.store.pipe(
      select(ReplacementDataMediumSourcesSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(ReplacementDataMediumSourcesActions.ReadReplacementDataMediumSources());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
